export default "__VITE_ASSET__B4qbR7pM__"